import { HttpServiceBase } from '../Http/HttpServiceBase';
import { strings } from '../../resources/strings';
import { Session } from '../../models/Session';
import { GetUserService } from '../../services/Users/GetUser/GetUserService';
import { GetUserInput } from '../../services/Users/GetUser/GetUserInput';

export class AuthService extends HttpServiceBase {

  constructor(
    private getUserService: GetUserService,
    http?: any | null
  ) {
    super(http);
  }

  authenticate = (email: string, password: string): Promise<Session | null> => {
    const promise = new Promise<Session | null>(async (resolve, reject) => {
      const input = new GetUserInput();
      input.email = email;
      input.password = password;

      try {
        const output = await this.getUserService.handle(input);

        const session = new Session();
        session.token = output?.value?.user?.token || output?.value?.user?.email;
        session.date = new Date();
        session.sessionExpiresAtUtcDate = output?.value?.user?.sessionExpiresAtUtcDate ? new Date(output?.value?.user?.sessionExpiresAtUtcDate) : null;
        session.sessionExpiresAtAmericaSaoPauloDate = output?.value?.user?.sessionExpiresAtAmericaSaoPauloDate ? new Date(output?.value?.user?.sessionExpiresAtAmericaSaoPauloDate) : null;
        session.user = output?.value?.user;
        session.locations = output?.value?.locations;
        session.userProfileConfig = output?.value?.userProfileConfig;
        session.restrictions = output?.value?.restrictions;

        if (session.user)
          resolve(session);
        else
          reject(strings.UserNotFound);
      } catch (error) {
        reject(error);
      }
    });

    return promise;
  }
}